export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9798.cc32c89a.jpg";